import React, { useState, useEffect } from "react";
import { Stack, Tooltip, styled, tooltipClasses } from "@mui/material";
import { Box, Button, Divider, Typography } from "@mui/material";
import Loader from "../../components/components/Loader";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddPhoto from "../../images/add_a_photo.png";
import PkgIcon from "../../images/package_2.svg";
import ShipIcon from "../../images/local_shipping.svg";
import VewsIcon from "../../images/store views.svg";
import LinkIcon from "../../images/link.svg";
import AddStore from "./AddStore";
import Cards from "./Cards";
import SendIcon from "@mui/icons-material/Send";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Link, useHistory } from "react-router-dom";
import CreateLink from "./CreateLink";
import { ImgBox, IndexItemBox, ListBox } from "./style";
import Repo from "../../Repository/Repo";
import { ClipLoader } from "react-spinners";
import ShareIcon from "@mui/icons-material/Share";
import { BodyContainer, Header, HeaderBtn, HeaderTitle } from "../bank/styles";
import AddImage from "./AddImage";

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "13px",
  fontWeight: 500,
  fontFamily: "Roboto",
  color: "#332233",
}));
const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Roboto",
  color: "#AFAFAF",
}));

const IconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#D7F5D8",
  borderRadius: "9px",
  height: "58px",
  width: "58px",
}));

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#ffffff",
    fontFamily: "Raleway",
    fontWeight: 500,
    color: "#353535",
    boxShadow: "0px 2px 4px 0px #0000002E",
    textAlign: "center",
    padding: "10px 20px",
    fontSize: "14px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#ffffff",
  },
});

function MyStore() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [storeData, setStoreData] = useState("");
  const [ordersInfo, setOrdersInfo] = useState(null);
  const [modals, setModals] = useState({
    addModal: false,
    linkModal: false,
    imgModal: false,
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getOrdersInfo();
    getStore();
  }, []);

  const getOrdersInfo = async () => {
    try {
      let { data } = await Repo.orders({
        request: {
          method: "getOrdersInfo",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      console.log("data:", data);
      if (data.response.status.statusCode == 200) {
        setOrdersInfo(data.response.data);
      }
    } catch (err) {
      setLoad(false);
      console.log(err);
    }
  };
  const getStore = async () => {
    try {
      setLoad(true);
      let { data } = await Repo.store({
        request: {
          method: "getStore",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoad(false);
      if (data.response.status.statusCode == 200) {
        if (data.response.data.stores.length > 0) {
          setStoreData(data.response.data.stores[0]);
        }
      }
    } catch (err) {
      setLoad(false);
      console.log(err);
    }
  };

  const toggle = (name) => {
    setModals((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const onSuccess = (arg) => {
    toggle(arg);
    getStore();
  };

  const handleItems = () => {
    history.push({
      pathname: "/inventory/admin/manage-items",
      state: storeData?.itemsArray || [],
    });
  };

  const handleCopy = () => {
    setIsOpen(true);

    setTimeout(() => {
      setIsOpen(false);
    }, 1000);

    navigator.clipboard
      .writeText(`https://managekaro.org/store/${storeData.userName}`)
      .then()
      .catch((error) => {
        console.error("Failed to copy text: ", error);
      });
  };

  const imageUploaded = (e) => {
    setStoreData(e);
    toggle("imgModal");
  };

  return (
    <Box sx={{ mt: 5 }}>
      <Header>
        {load && <Box></Box>}
        {load && <ClipLoader color="#ffffff" size={40} loading={true} />}
        {load && <Box></Box>}
        {!load && (
          <ImgBox>
            <img
              height="50px"
              width="50px"
              style={{ cursor: "pointer" }}
              src={storeData?.image || AddPhoto}
              alt=""
              onClick={() => toggle("imgModal")}
            />
          </ImgBox>
        )}
        {!load && (
          <HeaderTitle>
            {storeData ? storeData.storeName : "No Store"}
          </HeaderTitle>
        )}
        {!load && (
          <HeaderBtn variant="contained" onClick={() => toggle("addModal")}>
            {storeData ? "Edit Store Info" : "Create Store"}{" "}
            <BorderColorIcon
              sx={{ ml: 0.8, color: { xs: "#fff", sm: "#4eaf51" } }}
            />
          </HeaderBtn>
        )}
      </Header>

      <BodyContainer>
        {!loading && <Cards info={ordersInfo} />}
        {!loading && (
          <Box sx={{ background: "#FFFFFF", borderRadius: "7px", mt: 1.6 }}>
            <Title sx={{ color: "#AFAFAF", p: "8px 32px" }}>
              Quick Actions
            </Title>
            <Divider sx={{ mb: "8px" }} />
            <Box sx={{ background: "#FFFFFF", p: "8px 32px" }}>
              {/* <Link to="/inventory/admin/manage-items"> */}
              <IndexItemBox sx={{ cursor: "pointer" }} onClick={handleItems}>
                <Stack direction="row" alignItems="center" spacing="8px">
                  <IconBox>
                    <img src={PkgIcon} alt="" />
                  </IconBox>
                  <Stack>
                    <Title>Manage Items</Title>
                    <SubTitle>
                      Total items added - {storeData?.itemsArray?.length}
                    </SubTitle>
                  </Stack>
                </Stack>
                <SendIcon sx={{ color: "#64B868" }} />
              </IndexItemBox>
              {/* </Link> */}
              <Link to="/inventory/admin/manage-orders">
                <IndexItemBox sx={{ cursor: "pointer", my: "8px" }}>
                  <Stack direction="row" alignItems="center" spacing="8px">
                    <IconBox sx={{ background: "#EDF5D7" }}>
                      <img src={ShipIcon} alt="" />
                    </IconBox>
                    <Stack>
                      <Title>Manage Orders</Title>
                      <SubTitle>
                        Orders delivered till date -{" "}
                        {ordersInfo?.countDeliveredOrders || 0}
                      </SubTitle>
                    </Stack>
                  </Stack>
                  <SendIcon sx={{ color: "#B8B564" }} />
                </IndexItemBox>
              </Link>
              <IndexItemBox>
                <Stack direction="row" alignItems="center" spacing="8px">
                  <IconBox sx={{ background: "#F5E9D7" }}>
                    <img height="20px" src={VewsIcon} alt="" />
                  </IconBox>
                  <Stack>
                    <Title>Store Reports</Title>
                    <SubTitle>Today’s Sale - Rs 00.0</SubTitle>
                  </Stack>
                </Stack>
                <SendIcon sx={{ color: "#B88264" }} />
              </IndexItemBox>
              <IndexItemBox sx={{ my: "8px" }}>
                <Stack
                  direction="row"
                  width="100%"
                  alignItems="center"
                  spacing={1}
                >
                  <IconBox sx={{ background: "##D7F5DC" }}>
                    <img src={LinkIcon} alt="" />
                  </IconBox>
                  <ListBox>
                    <Stack direction="row" spacing="3px">
                      {storeData?.userName ? (
                        <a
                          href={`/store/${storeData.userName}`}
                          target="_blank"
                        >
                          <SubTitle sx={{ color: "#4CAF50" }}>
                            https://managekaro.org/store/{storeData.userName}
                          </SubTitle>
                        </a>
                      ) : (
                        <SubTitle sx={{ color: "#4CAF50" }}>
                          No store link -
                        </SubTitle>
                      )}
                      {!storeData?.userName && (
                        <SubTitle sx={{ color: "#AFAFAF" }}>
                          create new link
                        </SubTitle>
                      )}
                    </Stack>

                    <Typography sx={{ color: "#323232", fontSize: "12px" }}>
                      Share online store and start getting orders now !
                    </Typography>
                    <Stack>
                      {storeData && !storeData?.userName && (
                        <Button
                          size="small"
                          variant="contained"
                          sx={{
                            background: "#4CAF50 !important",
                            textTransform: "none",
                          }}
                          onClick={() => toggle("linkModal")}
                        >
                          <AddCircleIcon sx={{ color: "#ffffff", mr: 1 }} />
                          Create Online Store
                        </Button>
                      )}
                      {storeData?.userName && (
                        <CustomWidthTooltip
                          open={isOpen}
                          arrow
                          title="Copied !"
                        >
                          <Button
                            size="small"
                            variant="contained"
                            sx={{
                              background: "#4CAF50 !important",
                              textTransform: "none",
                            }}
                            onClick={handleCopy}
                          >
                            <ShareIcon sx={{ color: "#ffffff", mr: 1 }} /> Share
                            Store Online
                          </Button>
                        </CustomWidthTooltip>
                      )}
                    </Stack>
                  </ListBox>
                </Stack>
              </IndexItemBox>
            </Box>
          </Box>
        )}
        {loading && <Loader loading={true} />}
        {modals.addModal && (
          <AddStore
            onClose={() => toggle("addModal")}
            onSuccess={() => onSuccess("addModal")}
            store={storeData ? storeData : null}
          />
        )}
        {modals.linkModal && (
          <CreateLink
            onClose={() => toggle("linkModal")}
            id={storeData._id}
            userName={storeData?.userName ? storeData.userName : null}
            onSuccess={() => onSuccess("linkModal")}
          />
        )}
        {modals.imgModal && (
          <AddImage
            onClose={() => toggle("imgModal")}
            store={storeData ? storeData : null}
            onSuccess={imageUploaded}
          />
        )}
      </BodyContainer>
    </Box>
  );
}

export default MyStore;
